function* generateContinuousInt() {
  let n = 0;
  while (true) {
    yield n++;
  }
}

let numberGenerator = generateContinuousInt();

export const getContinuousNumber = () => numberGenerator.next().value + '';

export const resetContinuousNumber = () => {
  numberGenerator = generateContinuousInt();
};

// help generated protobuf clients and redux queries to work with bigints
export const convertBigInt = <T>(input: T) => {
  const serialized = JSON.stringify(input, (_, value) =>
    typeof value === 'bigint' ? Number(value) : value,
  );

  return JSON.parse(serialized) as T;
};
